import React, { useRef, useState } from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import { Row, Col } from 'react-bootstrap'
import { toast } from 'react-toastify'

function ImportarArchivo (props) {
  const { titulo, label, max, textoMax } = props
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const fileInputRef = useRef(null)

  const handleFileChange = (e) => {
    const selected = e.target.files[0]
    setError(null)

    if (!selected) return

    if (selected.size > max) {
      setError('El archivo supera el límite máximo.')
      toast.error('El archivo supera el límite máximo.')
      setFile(null)
      return
    }
    setFile(selected)
  }

  const handleUpload = async () => {
    if (!file) return
    setLoading(true)

    try {
      await new Promise(resolve => setTimeout(resolve, 2000))
      toast.success('Archivo procesado correctamente')
    } catch (err) {
      setError('Error al subir el archivo. Intente nuevamente.')
      toast.error('Error al subir el archivo. Intente nuevamente.')
    } finally {
      setLoading(false)
    }
  }

  // console.log('File: ', file)

  return (
    <Row style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Col md={12}>
        <h6 className='mb-3'>{titulo}</h6>

        <div
          className={`upload-zone ${error ? 'error' : ''} ${file ? 'success' : ''}`}
          onClick={() => fileInputRef.current.click()}
          role='button'
          aria-label={label}
        >
          <input
            type='file'
            ref={fileInputRef}
            onChange={handleFileChange}
            hidden
            accept='.csv, .xlsx, .pdf, .txt'
          />

          {file
            ? <strong>{file.name}</strong>
            : <span>Seleccionar o arrastrar archivo</span>
          }
        </div>

        <div className='file-info'>
          <small>{textoMax}</small>
        </div>

        {error && <div className='error-message'>{error}</div>}
      </Col>
      <Col md={3} style={{ margin: '2% auto' }}>
        <Button
          variant='contained'
          color='primary'
          fullWidth
          disabled={!file || loading}
          onClick={handleUpload}
          startIcon={loading && <CircularProgress size={20} color='inherit' />}
        >
          {loading ? 'Procesando...' : 'Importar'}
        </Button>
      </Col>
    </Row>
  )
}

export default ImportarArchivo
